import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const TICKETS_LEFT_THRESHOLD_QUERY_KEY = QUERY_KEYS.getCompanyTicketsLeftThreshold;

export interface TicketsLeftThreshold {
  ticketThreshold: number | null;
  guestListThreshold: number | null;
  bottleServiceThreshold: number | null;
  passThreshold: number | null;
}

const DEFAULT_TICKETS_LEFT_THRESHOLD = 10;

const THRESHOLD_BY_TYPE: Record<string, keyof TicketsLeftThreshold> = {
  ticket: 'ticketThreshold',
  bottleService: 'bottleServiceThreshold',
  guestList: 'guestListThreshold',
  seasonPass: 'passThreshold',
};

export const getTicketsLeftThresholdByType = (thresholds: TicketsLeftThreshold | undefined, type: string): number => {
  const key = THRESHOLD_BY_TYPE[type];
  return thresholds?.[key] ?? DEFAULT_TICKETS_LEFT_THRESHOLD;
};

const getCompanyTicketsLeftThreshold = async ({ companyId }: { companyId: string }) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/companies/${companyId}/tickets-left-threshold`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyTicketsLeftThreshold = ({
  companyId,
  options,
}: {
  companyId: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<TicketsLeftThreshold, RequestError>(
    [TICKETS_LEFT_THRESHOLD_QUERY_KEY, companyId],
    () => getCompanyTicketsLeftThreshold({ companyId }),
    options,
    true
  );
};
